import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ESectionType, Section } from 'Shared/components';
import { EProvider } from 'Common/consts';
import ErrorPlaceholder from 'Common/components/ErrorPlaceholder/ErrorPlaceholder';
import { getDatasetsCollection, getListFetchingError, getProviders, } from 'PhenotypeCatalogueView/store/selectors';
import { fetchDatasetsList } from 'PhenotypeCatalogueView/store/actions';
import CatalogueSection from './CatalogueSection';
import styles from './CatalogueSection.css';
const CatalogueSectionContainer = () => {
    const dispatch = useDispatch();
    const providers = useSelector(getProviders);
    const firstProvider = providers[0] === EProvider.UKB ? EProvider.UKB : EProvider.FinnGen;
    const [activeProvider, setActiveProvider] = useState(EProvider.UKB);
    useEffect(() => {
        dispatch(fetchDatasetsList({}));
        setActiveProvider(firstProvider);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstProvider]);
    const error = useSelector(getListFetchingError);
    const datasets = useSelector(getDatasetsCollection)[activeProvider];
    if (error) {
        return (_jsx(Section, Object.assign({ type: ESectionType.Minimized, className: styles.content }, { children: _jsx(ErrorPlaceholder, { layoutClassName: styles.errorLayout, contentClassName: styles.errorContent, titleClassName: styles.errorTitle, imgClassName: styles.errorImage, messageClassName: styles.errorMessage, message: "Application failed to load resources required for rendering the page" }, void 0) }), void 0));
    }
    if (!datasets) {
        return null;
    }
    return (_jsx(CatalogueSection, { datasets: datasets, activeProvider: activeProvider, changeProviderHandler: setActiveProvider }, void 0));
};
export default CatalogueSectionContainer;
